module.exports = __webpack_public_path__ + "media/images/covers/sw-thumb-06-e26ab22c2d5ad0c0f6231241ef347db7.jpg";